import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Loader } from '@/components/loaders/Loader'
import { PageHeader } from '@/components/headers/PageHeader'
import { Breadcrumbs } from '@/components/forms/Breadcrumbs/Breadcrumbs'
import NoData from '@/components/NoData'
import { setEditingTool } from '@/reducers/tools/tools.redux'
import { fetchTool } from '@/reducers/tools/tools.actions'

import { ToolForm } from './ToolForm'
import { isLiveToolType } from './tools.helpers'

const ToolFormPage = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const { editingTool, loading } = useSelector((state) => state.tools)

  const isCreate = id === 'create'

  useEffect(() => {
    if (!isCreate) {
      dispatch(fetchTool(id))
    } else {
      dispatch(setEditingTool(null))
    }

    return () => {
      dispatch(setEditingTool(null))
    }
  }, [id])

  if (!isCreate && loading.fetchTool && !editingTool) {
    return <Loader centered />
  }

  const isRetired = !isCreate && editingTool && !isLiveToolType(editingTool.type)
  const currentLink = isCreate ? 'Create' : `Edit ${editingTool?.name ?? ''}`.trim()

  return (
    <div data-testid="tool-form-page">
      <PageHeader
        breadcrumbs={
          <Breadcrumbs
            backLinks={[{ label: 'Tools', link: '/tools', dataTestId: 'breadcrumb-tools' }]}
            currentLink={currentLink}
          />
        }
      />
      {isRetired ? (
        <NoData
          headerText="This tool type is retired"
          text="Look Up and Notate tools can no longer be edited."
          data-testid="tool-retired-message"
        />
      ) : (
        <ToolForm tool={isCreate ? null : editingTool} />
      )}
    </div>
  )
}

export default ToolFormPage
